import { render, staticRenderFns } from "./SvgRoot.vue?vue&type=template&id=32961447"
import script from "./SvgRoot.vue?vue&type=script&lang=js"
export * from "./SvgRoot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports